import type { DataSourceAbstract, RichTextContentProtocol, RichTextOfTextNode, VariableADTvalue } from '@lighthouse/core'
import type { FlowNode, VariableTree2 } from '@lighthouse/shared'
import { getAllCanBeUpstreamNodes, getUpstreamNodesOptions, useAtomData } from '@lighthouse/shared'
import { useNodesData } from '@xyflow/react'
import { useMemo } from 'react'

import { workflowListAtom } from '@/atoms/workflow/state'

import { extractDataFn, textRichVariableName } from './util'

interface UseTakeVariableWithTextProps {
    value: undefined | RichTextContentProtocol
    dataSourceList: DataSourceAbstract[]
}

export const useTakeVariableWithText = ({ value, dataSourceList }: UseTakeVariableWithTextProps) => {
    const data = useMemo(() => extractDataFn(value), [value])
    const workflowList = useAtomData(workflowListAtom)
    const nodesEditorText = useNodesData(data.nodeIds) as FlowNode[]
    const upstreamOptions = useMemo(
        () =>
            getUpstreamNodesOptions({
                workflowList,
                dataSourceList,
                upstreamNodes: getAllCanBeUpstreamNodes(nodesEditorText || []),
                allUpstreamNodes: nodesEditorText
            }),
        [workflowList, dataSourceList, nodesEditorText]
    )

    return { upstreamOptions, data }
}

interface Props {
    nodes: (RichTextOfTextNode | VariableADTvalue)[]
    upstreamOptions?: VariableTree2[]
    userOption?: VariableTree2
}

export const TakeVariableWithText = ({ nodes, userOption, upstreamOptions }: Props) => {
    return (
        <>
            {nodes.map(item => {
                if (item.type === 'text') {
                    return <span key={item.value}>{item.value}</span>
                }
                const text = textRichVariableName({
                    userOption,
                    upstreamOptions,
                    data: item
                })
                return (
                    <span key={text} style={{ color: 'var(--color-purple-500)' }}>
                        {text}
                    </span>
                )
            })}
        </>
    )
}
